var _defs, _path, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsistenciaMedica(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 336 324",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#c1bebf;}.cls-3{fill:#238ccc;}.cls-4{fill:#07599b;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M80,252.87h191.89c-4.85-29.77-13.16-62.85-27.1-96.49H107.09l-.07,.16c-13.89,33.58-22.18,66.61-27.02,96.33"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.39,230.11l-1.75-.97c2.82-5.06,4.31-10.93,4.31-16.96,0-17.41-12.34-31.57-27.5-31.57s-27.5,14.16-27.5,31.57c0,6.03,1.49,11.89,4.3,16.96l-1.75,.97c-2.98-5.36-4.55-11.56-4.55-17.93,0-18.51,13.23-33.57,29.5-33.57s29.5,15.06,29.5,33.57c0,6.37-1.58,12.57-4.56,17.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M130.58,223.78c3,4.09,2.12,9.84-1.97,12.84-4.09,3-9.84,2.11-12.84-1.98-3-4.09-2.11-9.84,1.98-12.84,4.09-3,9.84-2.12,12.84,1.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164.32,223.77c-3,4.09-2.12,9.84,1.98,12.84,4.09,3,9.83,2.11,12.84-1.98,3-4.08,2.12-9.83-1.98-12.84-4.09-3-9.84-2.11-12.84,1.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.79,220.3c0,7.87-6.38,14.25-14.25,14.25s-14.25-6.38-14.25-14.25,6.38-14.25,14.25-14.25,14.25,6.38,14.25,14.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.6,221.3c-.25,0-.5-.09-.69-.28-.4-.38-.42-1.01-.04-1.41,.24-.26,23.96-26.04-1.54-66.34-.3-.47-.16-1.08,.31-1.38,.47-.29,1.08-.16,1.38,.31,7.59,11.99,15.6,30.42,10.68,50.11-2.96,11.82-9.12,18.4-9.38,18.67-.2,.21-.46,.31-.72,.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "131.54 186.46 129.78 185.52 147.45 152.42 165.12 185.52 163.36 186.46 147.45 156.67 131.54 186.46"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M133.67,99.08c0-25.97,21.05-47.01,47.02-47.01s47.01,21.05,47.01,47.01v11.59h-94.03v-11.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M180.3,144.53c23.71,0,42.93-19.22,42.93-42.93s-19.22-42.93-42.93-42.93-42.93,19.22-42.93,42.93,19.22,42.93,42.93,42.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M180.69,52.07c-24.65-1.3-46.49,16.44-53.41,35.99,9.24,11.06,23.14,18.11,38.68,18.11,21.92,0,40.57-14.01,47.5-33.56-9.24-11.06-17.24-19.72-32.76-20.54"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 133.67,
    y: 94.46,
    width: 13.93,
    height: 16.21
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "170.92 150.44 202.87 171.08 202.87 150.25 195.44 147.42 170.92 150.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "182.07 155.42 157.83 171.09 157.83 150.24 168.91 146.58 182.07 155.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M180.37,178.38c-1.62,0-2.92-1.29-2.94-2.89-.02-1.61,1.27-2.92,2.88-2.94,1.61-.02,2.92,1.28,2.94,2.89,0,1.61-1.29,2.92-2.88,2.94"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsistenciaMedica);
export default __webpack_public_path__ + "static/media/AsistenciaMedica.2b1a54fc6d72756f37c8f065057beabc.svg";
export { ForwardRef as ReactComponent };